import React, { forwardRef } from 'react';

import { CustomButton as Button } from 'components/commonStyles';

// Helper function to map custom sizes to Ant Design sizes
const mapSizeToAntSize = (size) => {
  switch (size) {
    case 'smallest':
      return 'small';
    case 'small':
      return 'small';
    case 'medium':
      return 'default';
    case 'default':
      return 'default';
    case 'large':
      return 'large';
    default:
      return 'default';
  }
};

const CustomButton = forwardRef(({ size = 'large', highlightIcons = true, ...props }, ref) => {
  // Map the custom size to Ant Design size for the underlying Button component
  const antSize = mapSizeToAntSize(size);

  return <Button ref={ref} size={antSize} originalSize={size} highlightIcons={highlightIcons} {...props} />;
});

CustomButton.__ANT_BUTTON = true;

export default CustomButton;
